import Dropdown, { IDropdown } from '../../Dropdown/Dropdown'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { CONTRIBUTOR_RIGHTS } from '../utils'

const UserAccessDropdown = (props: IDropdown) => {
  const { t } = useUIComponentsContext()

  const data = Object.values(CONTRIBUTOR_RIGHTS(t))

  return (
    <Dropdown textField="label" valueField="value" data={data} {...props} />
  )
}

export default UserAccessDropdown
